import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';
import headers from '@/constants/headers';

axios.defaults.headers.common.Authorization = `Bearer ${headers.access_token}`;

const transactionsService = {
  async nextAdministrativeUnits(){
    return (await axios.get(`${API_V2_URL()}/transactions/transactions/next_administrative_units`)).data
  },
  sendFolderToReview(payload) {
    return axios.post('transaction_flows/transactions/transaction_to_revision', payload);
  },
  getFieldsTransaction() {
    return axios.get('transaction_flows/transactions/fields_transaction');
  },
};

export default transactionsService;



// WEBPACK FOOTER //
// ./src/services/TransactionsService.js